<template>
    <div>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">客户登录统计</span>
                        <span style="margin-left:10px;">统计时间:</span>
                        <DatePicker type="daterange"
                            :value="selectDates"
                            size="small"
                            transfer
                            :clearable="false"
                            placement="bottom-end"
                            placeholder="选择期初和期末时间"
                            style=" margin-left:4px;width: 180px"
                            @on-change="onDateChange"></DatePicker>
                        <span style="margin-left:10px;">登录会员(去重):{{userLoginCount}}</span>
                        <span style="margin-left:10px;">有采购的会员:{{userSaleCount}}</span>
                        <span style="margin-left:10px;">采购比:{{saleLoginRate}}</span>
                    </div>
                    <div class="right-bar">

                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { numberToFixed, number2ThousandsFormat } from '@/components/number-input/display-format';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';
import { customerLoginStat } from '@/api/modules/stat-analyze/customer-analyze';

export default {
    name: 'CustomerLoginStat',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            selectDates: [],
            btnLoading: false,
            mainTable: {
                tableColumns: [
                    { title: '登录时间', key: 'actionCreatedAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.actionCreatedAt) },
                    { title: '账号', key: 'actionUserName', align: 'center' },
                    { title: '名称', key: 'actionUserPersonName', align: 'center' },
                    { title: '登录IP', key: 'actionIp', align: 'center' },
                    { title: '登录次数', key: 'loginTimes', align: 'center' }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams()
            },
            userLoginCount: 0,
            userSaleCount: 0,
            saleLoginRate: '0%'
        };
    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.init();
    },
    methods: {
        getTodayDateString,
        getThisMonthStart,
        init() {
            this.getMainTableRecords();
        },
        onDateChange(e) {
            this.selectDates = e;
            this.getMainTableRecords(true);
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            customerLoginStat(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    this.userLoginCount = res.data.userLoginCount;
                    this.userSaleCount = res.data.userSaleCount;
                    this.saleLoginRate = res.data.saleLoginRate;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>